var map = {
	"./": 8305,
	"./App": 9555,
	"./App.js": 9555,
	"./App.module.css": 3250,
	"./assets/background-stars.svg": 7267,
	"./assets/favicon-32x32.png": 5024,
	"./assets/geology-earth.png": 6154,
	"./assets/geology-jupiter.png": 3855,
	"./assets/geology-mars.png": 9340,
	"./assets/geology-mercury.png": 4313,
	"./assets/geology-neptune.png": 9026,
	"./assets/geology-saturn.png": 7981,
	"./assets/geology-uranus.png": 3566,
	"./assets/geology-venus.png": 8371,
	"./assets/icon-cancel.svg": 7352,
	"./assets/icon-chevron.svg": 5537,
	"./assets/icon-hamburger.svg": 4421,
	"./assets/icon-source.svg": 3291,
	"./assets/planet-earth-internal.svg": 6097,
	"./assets/planet-earth.svg": 508,
	"./assets/planet-jupiter-internal.svg": 4087,
	"./assets/planet-jupiter.svg": 6578,
	"./assets/planet-mars-internal.svg": 2287,
	"./assets/planet-mars.svg": 7888,
	"./assets/planet-mercury-internal.svg": 4635,
	"./assets/planet-mercury.svg": 7225,
	"./assets/planet-neptune-internal.svg": 3150,
	"./assets/planet-neptune.svg": 3232,
	"./assets/planet-saturn-internal.svg": 2746,
	"./assets/planet-saturn.svg": 1389,
	"./assets/planet-uranus-internal.svg": 1369,
	"./assets/planet-uranus.svg": 2678,
	"./assets/planet-venus-internal.svg": 1298,
	"./assets/planet-venus.svg": 8382,
	"./components/Article": 5796,
	"./components/Article/": 5796,
	"./components/Article/Article": 2806,
	"./components/Article/Article.jsx": 2806,
	"./components/Article/Article.module.css": 1529,
	"./components/Article/index": 5796,
	"./components/Article/index.jsx": 5796,
	"./components/ElementList": 2012,
	"./components/ElementList/": 2012,
	"./components/ElementList/ElementList": 2581,
	"./components/ElementList/ElementList.jsx": 2581,
	"./components/ElementList/ElementList.module.css": 6318,
	"./components/ElementList/index": 2012,
	"./components/ElementList/index.jsx": 2012,
	"./components/Footer": 9817,
	"./components/Footer/": 9817,
	"./components/Footer/Footer": 3000,
	"./components/Footer/Footer.jsx": 3000,
	"./components/Footer/Footer.module.css": 2747,
	"./components/Footer/index": 9817,
	"./components/Footer/index.jsx": 9817,
	"./components/Header": 5098,
	"./components/Header/": 5098,
	"./components/Header/Header": 8396,
	"./components/Header/Header.jsx": 8396,
	"./components/Header/Header.module.css": 7604,
	"./components/Header/index": 5098,
	"./components/Header/index.jsx": 5098,
	"./components/Main": 3424,
	"./components/Main/": 3424,
	"./components/Main/Main": 3318,
	"./components/Main/Main.jsx": 3318,
	"./components/Main/Main.module.css": 8910,
	"./components/Main/index": 3424,
	"./components/Main/index.jsx": 3424,
	"./components/MenuButton": 6898,
	"./components/MenuButton/": 6898,
	"./components/MenuButton/MenuButton": 569,
	"./components/MenuButton/MenuButton.jsx": 569,
	"./components/MenuButton/MenuButton.module.css": 8301,
	"./components/MenuButton/index": 6898,
	"./components/MenuButton/index.jsx": 6898,
	"./components/NavBar": 6714,
	"./components/NavBar/": 6714,
	"./components/NavBar/NavBar": 4427,
	"./components/NavBar/NavBar.jsx": 4427,
	"./components/NavBar/NavBar.module.css": 6961,
	"./components/NavBar/index": 6714,
	"./components/NavBar/index.jsx": 6714,
	"./components/Orbital": 6812,
	"./components/Orbital/": 6812,
	"./components/Orbital/Orbital": 5012,
	"./components/Orbital/Orbital.jsx": 5012,
	"./components/Orbital/Orbital.module.css": 2431,
	"./components/Orbital/index": 6812,
	"./components/Orbital/index.jsx": 6812,
	"./components/Planet": 4206,
	"./components/Planet/": 4206,
	"./components/Planet/Planet": 9584,
	"./components/Planet/Planet.jsx": 9584,
	"./components/Planet/Planet.module.css": 3736,
	"./components/Planet/index": 4206,
	"./components/Planet/index.jsx": 4206,
	"./components/Section": 2205,
	"./components/Section/": 2205,
	"./components/Section/Section": 1294,
	"./components/Section/Section.jsx": 1294,
	"./components/Section/Section.module.css": 4063,
	"./components/Section/index": 2205,
	"./components/Section/index.jsx": 2205,
	"./data": 468,
	"./data.json": 468,
	"./index": 8305,
	"./index.js": 8305
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8116;